module.exports = __webpack_public_path__ + "img/successIcon.305792f2.png";